<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"BUTTON.VIEW" | translate}} {{"MENUITEMS.IMPNOTICE.NOTICE" | translate}}</h5>
      <div class="edit-icons" mat-dialog-close="">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content d-flex flex-column p-2" >
          
        <div class="i-img d-box">
            <img src="assets/images/icons/attention.svg" class="img-fluid">
        </div>
        <div class="d-box">
           <h4 class="text-center mt-3">{{dialogData.tit}}</h4>
           <div class="ql-box">
            <div class="i-content mt-3" [innerHTML]="desc | safe:'html'"></div>
           </div>
         
        </div>
     
    </div>
</div>